var render = function render(_c,_vm){return _c('div',{staticClass:"administration-widget-wrap"},[_c('div',{staticClass:"administration-widget"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }